export const translations = {
  cnpjInvalido: {
    pt: "CNPJ/CPF Inválido",
    en: "Invalid CNPJ/CPF",
    de: "CNPJ/CPF ungültig",
    es: "CNPJ/CPF no válido",
  },
  obrigatorio: {
    pt: "Obrigatório",
    en: "Mandatory",
    de: "Pflichtfeld",
    es: "Obligatorio",
  },
  cnpj: {
    pt: "CNPJ/CPF",
    en: "CNPJ/CPF",
    de: "CNPJ/CPF",
    es: "CNPJ/CPF",
  },
  idExterior: {
    pt: "ID Exterior",
    en: "Foreign ID",
    de: "ID Ausland",
    es: "DNI extranjero",
  },
  emailInvalido: {
    pt: "Email inválido",
    en: "Invalid email",
    de: "Ungültige E-Mail-Adresse",
    es: "Email inválido",
  },
  codigoInvalido: {
    pt: "Código inválido",
    en: "Invalid code",
    de: "Ungültiger Code",
    es: "Codigo invalido",
  },
  CEPnaoEncontrado: {
    pt: "CEP não encontrado",
    en: "CEP not found",
    de: "Postleitzahl nicht gefunden",
    es: "CEP no encontrado",
  },
  CEPInvalido: {
    pt: "CEP inválido",
    en: "Invalid zip code",
    de: "Ungültige Postleitzahl",
    es: "Código postal no válido",
  },
  configuracoes: {
    pt: "Configurações",
    en: "Settings",
    de: "Einstellungen",
    es: "Configuración",
  },
  novoCliente: {
    pt: "Novo cliente",
    en: "New customer",
    de: "Neuer Kunde",
    es: "Nuevo cliente",
  },
  voltar: {
    pt: "Voltar",
    en: "Go back",
    de: "Zurück",
    es: "Regresa",
  },
  estrangeiro: {
    pt: "Estrangeiro",
    en: "Foreign",
    de: "Ausland",
    es: "Extranjero",
  },
  nacional: {
    pt: "Nacional",
    en: "Nacional",
    de: "Inland",
    es: "Nacional",
  },
  razaoSocial: {
    pt: "Razão Social",
    en: "Social Reason",
    de: "Firmenname",
    es: "Razón Social",
  },
  nomeFantasia: {
    pt: "Nome",
    en: "name",
    de: "name",
    es: "Nombre",
  },
  novoCommercialTeam: {
    pt: "Novo Time Comercial",
    en: "New Commercial Team",
    de: "Neues Vertriebsteam",
    es: "Nuevo Equipo Comercial",
  },
  trackingRegion: {
    pt: "Região de Rastreamento",
    en: "Tracking Region",
    de: "Verfolgungsregion",
    es: "Región de Seguimiento",
  },
  commercialRole: {
    pt: "Função Comercial",
    en: "Commercial Role",
    de: "Kommerzielle Rolle",
    es: "Rol Comercial",
  },
  codigoSAP: {
    pt: "Código ERP",
    en: "ERP code",
    de: "ERP-Code",
    es: "código ERP",
  },
  segmentacao: {
    pt: "Customer segmentation",
    en: "Customer segmentation",
    de: "Kundensegmentierung",
    es: "Segmentación de clientes",
  },
  inscricaoEstatual: {
    pt: "Inscrição Estadual",
    en: "State registration",
    de: "Staatliche Registrierung",
    es: "Registro estatal",
  },
  telefone: {
    pt: "Telefone",
    en: "Telephone",
    de: "Telefon",
    es: "Teléfono",
  },
  email: {
    pt: "E-mail",
    en: "E-mail",
    de: "E-mail",
    es: "Correo electrónico",
  },
  cep: {
    pt: "Cep",
    en: "Zip code",
    de: "Postleitzahl",
    es: "Código postal",
  },
  uf: {
    pt: "UF",
    en: "Federative unit",
    de: "Bundesstaat",
    es: "Unidad federativa",
  },
  lougradouro: {
    pt: "Logradouro",
    en: "Public place",
    de: "Adresse",
    es: "Lugar público",
  },
  numero: {
    pt: "Número",
    en: "Number",
    de: "Hausnummer",
    es: "Número",
  },
  bairro: {
    pt: "Bairro",
    en: "Neighborhood",
    de: "Stadtviertel",
    es: "Barrio",
  },
  cidade: {
    pt: "Cidade",
    en: "City",
    de: "Ort",
    es: "Ciudad",
  },
  latitude: {
    pt: "Latitude",
    en: "Latitude",
    de: "Breitengrad",
    es: "Latitud",
  },
  longitude: {
    pt: "Longitude",
    en: "Longitude",
    de: "Längengrad",
    es: "Longitud",
  },
  necessitaAgendamento: {
    pt: "Necessita agendamento",
    en: "Need scheduling",
    de: "Terminplanung erforderlich",
    es: "Necesita programar",
  },
  infoEntrega: {
    pt: "Informações de entrega:",
    en: "Delivery information:",
    de: "Lieferinformationen:",
    es: "Información de entrega:",
  },
  segunda: {
    pt: "Segunda",
    en: "Monday",
    de: "Montag",
    es: "Lunes",
  },
  terca: {
    pt: "Terça",
    en: "Tuesday",
    de: "Dienstag",
    es: "Martes",
  },
  quarta: {
    pt: "Quarta",
    en: "Wednesday",
    de: "Mittwoch",
    es: "Miércoles",
  },
  quinta: {
    pt: "Quinta",
    en: "Thursday",
    de: "Donnerstag",
    es: "Jueves",
  },
  sexta: {
    pt: "Sexta",
    en: "Friday",
    de: "Freitag",
    es: "Viernes",
  },
  sabado: {
    pt: "Sábado",
    en: "Saturday",
    de: "Samstag",
    es: "Sábado",
  },
  domingo: {
    pt: "Domingo",
    en: "Sunday",
    de: "Sonntag",
    es: "Domingo",
  },
  inicioRecebimento: {
    pt: "Início de recebimento",
    en: "Start of receipt",
    de: "Beginn des Empfangs",
    es: "Inicio de recibo",
  },
  fimRecebimento: {
    pt: "Fim de recebimento",
    en: "End of receipt",
    de: "Ende des Empfangs",
    es: "Fin de recibo",
  },
  inicioRefeicao: {
    pt: "Início de refeição",
    en: "Meal start",
    de: "Beginn der Mahlzeit",
    es: "Comienzo de la comida",
  },
  fimRefeicao: {
    pt: "Fim de refeição",
    en: "End of meal",
    de: "Ende der Mahlzeit",
    es: "Final de la comida",
  },
  observacao: {
    pt: "Observação",
    en: "Observation",
    de: "Überwachung",
    es: "Observación",
  },
  cancelar: {
    pt: "Cancelar",
    en: "Cancel",
    de: "Abbrechen",
    es: "Cancelar",
  },
  cadastrar: {
    pt: "Cadastrar",
    en: "Register",
    de: "Registrieren",
    es: "Register",
  },
  selecione: {
    pt: "Selecione...",
    en: "Select...",
    de: "Wählen Sie...",
    es: "Seleccione...",
  },
  IdExterior: {
    pt: "Id Exterior",
    en: "External ID",
    de: "Externe ID",
    es: "ID externa",
  },
  pais: {
    pt: "País",
    en: "Country",
    de: "Land",
    es: "País",
  },
  transportadora: {
    pt: "Transportadora",
    en: "Carrier",
    de: "Träger",
    es: "Portador",
  },
  erpCodeIsRequired: {
    pt: "O código ERP é um campo obrigatório",
    en: "ERP code is a required field",
    de: "ERP-Code ist ein Pflichtfeld",
    es: "El código ERP es un campo obligatorio",
  },
  nameIsRequired: {
    pt: "O nome é um campo obrigatório",
    en: "Name is a required field",
    de: "Name ist ein Pflichtfeld",
    es: "El nombre es un campo obligatorio",
  },

  phoneNumberIsRequired: {
    pt: "O número de telefone é um campo obrigatório",
    en: "Phone number is a required field",
    de: "Telefonnummer ist ein Pflichtfeld",
    es: "El número de teléfono es un campo obligatorio",
  },

  commercialRoleIsRequired: {
    pt: "A função comercial é um campo obrigatório",
    en: "Commercial role is a required field",
    de: "Kommerzielle Rolle ist ein Pflichtfeld",
    es: "El rol comercial es un campo obligatorio",
  },

  trackingRegionIsRequired: {
    pt: "A região de rastreamento é um campo obrigatório",
    en: "Tracking region is a required field",
    de: "Verfolgungsregion ist ein Pflichtfeld",
    es: "La región de seguimiento es un campo obligatorio",
  },
  newCommercialTeamRegisteredSuccessfully: {
    pt: "Novo time comercial cadastrado com sucesso!",
    en: "New commercial team registered successfully!",
    de: "Neues Vertriebsteam erfolgreich registriert!",
    es: "¡Nuevo equipo comercial registrado con éxito!",
  },

  errorRegisteringCommercialTeam: {
    pt: "Oops! Não foi possível cadastrar.",
    en: "Oops! It was not possible to register.",
    de: "Oops! Die Registrierung war nicht möglich.",
    es: "¡Oops! No fue posible registrar.",
  },
}
